export const AUTO_PAUSE_TIMEOUT_MINUTES = 5;
export const AUTO_PAUSE_WARNING_MESSAGE = 'Your task will be paused soon due to inactivity.';
export const TRACKING_MEDIA_ID = 'keyframe-tracking';